<template>
    <div class="fans" :class="{bg_height:isEmpty }">
        <ddHeader :title="titleName"></ddHeader>
        <div class="fans_item_contain" :class="{bg_empty:isEmpty ,bg_height:isEmpty}">
            <fans-item :name="item.nickname" :img-src="item.portrait_url" :jump-link="item.link_url" v-for="item in list" :key="item.id"></fans-item>
            <infinite-loading :on-infinite="onInfinite" ref="infiniteLoading">
    
                <div class="empty" slot="no-results">
                    <img src="../assets/images/failure.png" alt="">
                    <h2>{{emptyText}}</h2>
                </div>
            </infinite-loading>
        </div>
    </div>
</template>

<script>
import ddHeader from './header.vue'
import fansItem from './fansitem.vue'
import InfiniteLoading from './InfiniteLoading'
export default {
    name: 'myfans',
    components: { ddHeader, fansItem, InfiniteLoading },
    data() {
        return {
            list: [],
            page: 1,
            isEmpty: false
        }
    },
    computed: {
        titleName() {
            if (this.$store.state.isSelf) {
                return '我的粉丝'
            } else {
                return this.$store.state.TA + '的粉丝'
            }
        },
        emptyText(){
            if(this.$store.state.isSelf){
                return '您还没有粉丝!'
            }else{
                return this.$store.state.TA +'还没有粉丝!'
            }
        }
    },
    methods: {
        onInfinite() {
            this.$http({
                url: 'my.php',
                method: 'post',
                data: {
                    action: 'fans_list',
                    page: this.page++,
                    page_size: 15
                }
            }).then((res) => {
                var data = res.data;
                if (data.errorCode == 0 && data.data) {
                    var listData = data.data;
                    // this.page = 2;
                    // listData.length= 0;
                    if (this.page == 2) {
                        if (!listData.length) {
                            this.isEmpty = true;
                            this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete');
                        }
                    }
                    if (data.data.length) {
                        this.isEmpty = false;
                        this.list = this.list.concat(data.data);
                        this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded');
                    } else {
                        this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete');
                    }
                } else {
                    this.isEmpty = true;
                    this.errobj = {
                        type: 'pop',
                        errorMsg: data.errorMsg
                    }
                    this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete');
                }
            }).catch((e) => {
                this.errobj = {
                    type: 'pop',
                    errorMsg: '网络错误请稍后重试'
                }
            })
        }
    },
}
</script>

<style lang="stylus"> 
</style>



// WEBPACK FOOTER //
// myfans.vue?79695996